import SeeAllNotificationsContainer from "./SeeAllNotificationsContainer";

export default SeeAllNotificationsContainer;
